import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { format } from 'date-fns';
import Box from '../Box';
import defaultTheme from '../system/default-theme';
import Divider from '../Divider';
import Dropdown from '../Dropdown';
import Icon from '../Icon';
import Link from '../Link';
import StackView from '../StackView';
import Text from '../Text';
import { cloneChildren } from '../utils';

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "exclamation-triangle-filled",
  color: "#e8833a",
  marginTop: "3px"
});

var _ref3 = /*#__PURE__*/React.createElement(Divider, null);

var _ref4 = /*#__PURE__*/React.createElement(Icon, {
  name: "inactive",
  color: "grey-8",
  marginTop: "3px"
});

var _ref5 = /*#__PURE__*/React.createElement(Divider, null);

var _ref6 = /*#__PURE__*/React.createElement(Box, {
  height: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement(Box, {
  marginHorizontal: 2,
  padding: 1,
  backgroundColor: "surfaceTertiary",
  color: "foregroundSecondary"
}, /*#__PURE__*/React.createElement(Text, {
  size: 5,
  lineHeight: 2
}, "To delete this profile, an administrator must remove them from People."));

var _ref8 = /*#__PURE__*/React.createElement(Box, {
  height: 1
});

export function ActionsDropdown(_ref) {
  var children = _ref.children,
      _ref$defaultButtonPro = _ref.defaultButtonProps,
      defaultButtonProps = _ref$defaultButtonPro === void 0 ? defaultTheme.button.themes.primary.fill : _ref$defaultButtonPro,
      duplicates = _ref.duplicates,
      _ref$duplicatesButton = _ref.duplicatesButtonProps,
      duplicatesButtonProps = _ref$duplicatesButton === void 0 ? {
    color: 'white',
    backgroundColor: 'hsl(25deg 79% 57%)',
    hover: {
      backgroundColor: 'hsl(25deg 80% 54%)'
    },
    active: {
      backgroundColor: 'hsl(25deg 82% 51%)'
    }
  } : _ref$duplicatesButton,
      inactive = _ref.inactive,
      _ref$inactiveButtonPr = _ref.inactiveButtonProps,
      inactiveButtonProps = _ref$inactiveButtonPr === void 0 ? {
    color: 'white',
    backgroundColor: '#999B96'
  } : _ref$inactiveButtonPr,
      isBelowManager = _ref.isBelowManager,
      isPeopleProduct = _ref.isPeopleProduct,
      onDeleteProfile = _ref.onDeleteProfile;
  var hasDuplicates = (duplicates == null ? void 0 : duplicates.amount) > 0;
  var hasInactiveDate = Boolean(inactive == null ? void 0 : inactive.date);
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    title: "Actions",
    iconLeft: hasDuplicates || hasInactiveDate ? {
      name: hasDuplicates ? 'exclamation-triangle-filled' : 'inactive',
      size: 'lg'
    } : undefined,
    fontSize: "14px",
    fontWeight: 400,
    paddingLeft: hasDuplicates || hasInactiveDate ? 1 : undefined,
    paddingVertical: 0.25,
    theme: false,
    popoverProps: {
      maxWidth: '280px'
    },
    placement: "bottom-start"
  }, hasDuplicates ? duplicatesButtonProps : hasInactiveDate ? inactiveButtonProps : defaultButtonProps), hasDuplicates ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    padding: 2,
    spacing: 1
  }, _ref2, /*#__PURE__*/React.createElement(Text, {
    size: 4
  }, "There ", duplicates.amount > 1 ? 'are' : 'is', " ", duplicates.amount, ' ', "potential ", duplicates.amount > 1 ? 'duplicates' : 'duplicate', " for this profile.", ' ', isBelowManager ? "An administrator can resolve " + (duplicates.amount > 1 ? "them" : "it") + " in People." : /*#__PURE__*/React.createElement(Link, duplicates.linkProps, isPeopleProduct ? 'Review' : 'Review in People'))), _ref3) : null, hasInactiveDate ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    padding: 2,
    spacing: 1
  }, _ref4, /*#__PURE__*/React.createElement(Text, {
    size: 4
  }, "Set inactive on ", format(inactive.date, 'MMM dd, yyyy'), inactive.reason && " (" + inactive.reason + ")", ".", ' ', isBelowManager ? 'An administrator can reactivate them in People.' : /*#__PURE__*/React.createElement(Link, inactive.linkProps, isPeopleProduct ? 'Reactivate' : 'Reactivate in People'))), _ref5) : null, (hasDuplicates || hasInactiveDate) && _ref6, cloneChildren(children, function () {
    return {
      paddingHorizontal: 2
    };
  }), onDeleteProfile ? /*#__PURE__*/React.createElement(Dropdown.Item, {
    disabled: isBelowManager,
    paddingHorizontal: 2,
    onSelect: onDeleteProfile
  }, isPeopleProduct ? 'Delete profile' : 'Delete profile…') : null, onDeleteProfile && isBelowManager ? _ref7 : null, (hasDuplicates || hasInactiveDate || onDeleteProfile && isBelowManager) && _ref8);
}